export const presence = val => {
    if (val === undefined || val === null) {
        return 'Required';
    }
    if (val === 0) {
        return undefined;
    }
    return val ? undefined : 'Required';
};

export const minLength = min => val => presence(val) || (val.length >= min ? undefined : `Minimun length is ${min}`);

export const numeric = val => {
    if (!val) {
        return undefined;
    }
    return String(Number(val)) === String(val) ? undefined : 'Should be numeric value';
};

export const parseNumber = val => {
    return val !== '' ? Number(val) : val;
};

export const normalizeArray = isNumeric => value => {
    if (typeof value === 'string') {
        const arr = value.split(/[ ,]+/);
        if (isNumeric) {
            return arr.map(parseNumber).filter(isFinite);
        }
        return arr;
    }
    return value;
};

export const formatArray = (value = []) => {
    if (Array.isArray(value)) {
        return value.join(' ');
    }
    return value;
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/helpers/validation.js
 **/